import TimeIcon from "@mui/icons-material/AccessTimeRounded";
import CheckIcon from "@mui/icons-material/CheckRounded";
import { Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import useFetch from "@entrilia/shared/hooks/useFetch";
import useSetInterval from "@entrilia/shared/hooks/useSetInterval";
import { logError } from "@entrilia/shared/logging";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import adminApi from "../../../../api/adminApi";

const getInvestorPortalSyncStatus = withErrorHandling(adminApi.getInvestorPortalSyncStatus);

const InvestorPortalSyncStatusInfo = () => {
  const [syncStatus, , { setData: setSyncStatus }] = useFetch(adminApi.getInvestorPortalSyncStatus);

  const updateSyncStatus = useCallback(async () => {
    const [resp, error] = await getInvestorPortalSyncStatus();
    if (error) {
      logError(error, "[InvestorPortalSyncStatusInfo] getInvestorPortalSyncStatus");
    } else {
      setSyncStatus(resp);
    }
  }, [setSyncStatus]);

  useSetInterval(updateSyncStatus, 12_000);

  if (syncStatus === undefined) {
    return null;
  }

  const { isSyncActive, lastSyncTimestamp } = syncStatus;
  if (isSyncActive) {
    return (
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <TimeIcon color="action" />
        <Typography>Sync in progress...</Typography>
      </Stack>
    );
  }

  if (lastSyncTimestamp) {
    return (
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <CheckIcon color="primary" />
        <Typography>
          <Typography component="span" color="textSecondary">
            Last Sync:
          </Typography>
          <Typography component="span"> {convertISODateTime(lastSyncTimestamp)}</Typography>
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <CheckIcon color="primary" />
      <Typography>Sync successful</Typography>
    </Stack>
  );
};

export default InvestorPortalSyncStatusInfo;
